import { render } from "./DatabaseConfigScreen.vue?vue&type=template&id=306b7b09&scoped=true"
import script from "./DatabaseConfigScreen.vue?vue&type=script&lang=js"
export * from "./DatabaseConfigScreen.vue?vue&type=script&lang=js"

import "./installer-page.scss?vue&type=style&index=0&id=306b7b09&lang=scss&scoped=true"
import "./DatabaseConfigScreen.vue?vue&type=style&index=1&id=306b7b09&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\orangehrm-5.8\\installer\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-306b7b09"]])

export default __exports__